export interface ebook {
    courseId: string,
    materialId: string,
    participantId: string,
    formData: string
}

export function EbookDefaultValues(): ebook {
  return {
      courseId: '',
      materialId: '',
      participantId: '',
      formData: ''
  }
}

